import type { Options } from '@atlassiansox/cross-flow-support/cross-flow-api-internals';
import { CrossflowCtaPrimaryLinkButton } from '@post-office/components--crossflow-cta-button';
import { type FunctionComponent } from 'react';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { type App } from '../../types';

const JOURNEY = 'get-started';
const SOURCE_COMPONENT = 'jira-your-work';
const SOURCE_CONTEXT = 'tryItNow';

const tryItNowButtonText = (
	<FormattedMessage
		id="post-office.jira-your-work-first-party-recommendation.try-it-now"
		defaultMessage="Try it now"
		description={`CTA button text to try the product for the Jira Your Work first party recommendation`}
	/>
);

export const TryItNowButton: FunctionComponent<{ app: App }> = ({ app }) => {
	const crossflowOptions: Options = {
		targetProduct: app.hamsIdentifier,
		journey: JOURNEY,
		sourceComponent: SOURCE_COMPONENT,
		sourceContext: SOURCE_CONTEXT,
	};

	return (
		<CrossflowCtaPrimaryLinkButton
			crossflowOptions={crossflowOptions}
			ctaText={tryItNowButtonText}
			appearance="default"
		/>
	);
};
